import React from 'react';
import { gql, useQuery } from '@apollo/client';

const GET_FEATURES = gql`
  query Features($slug: String!) {
    product(slug: $slug) {
      features {
        id
        content {
          et
        }
      }
      description {
        featuresTitle
      }
    }
  }
`;

type FeatureItem = {
  id: string;
  content: {
    et: string;
  };
};

type DescriptionItem = {
  featuresTitle: string;
};

type Props = {
  slug: string;
};

export default function ProductFeatures({ slug }: Props) {
  const { data, loading } = useQuery<{
    product: {
      features: FeatureItem[];
      description: DescriptionItem;
    };
  }>(GET_FEATURES, {
    variables: { slug },
  });

  if (!data || loading) {
    return null;
  }

  return (
    <div>
      {data.product.description.featuresTitle ? (
        <div className="mt-5">
          <div className="text-base font-axi-bold">
            {data.product.description.featuresTitle}
          </div>
          <div className="m-5">
            <ul className="space-y-3 ml-4 list-disc">
              {data.product.features.map((feature) => (
                <li className="text-base" key={feature.id}>
                  <p className="ml-2">{feature.content?.et}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : null}
    </div>
  );
}
